import { derivedThemeValues } from '@/services/widgetTheme/derivedValues';
export const FORM = derivedThemeValues(_ref => {
  let {
    theme
  } = _ref;
  return {
    slider: {
      rail: {
        color: '#22262E'
      },
      tooltip: {
        backgroundColor: '#22262E'
      }
    },
    input: {
      borderColor: theme.color.border,
      borderColorHover: theme.color.borderHover,
      fontColor: theme.color.bodyFont,
      backgroundColor: '#151A1F',
      placeholder: {
        color: '#343B45'
      }
    },
    label: {
      color: theme.color.bodyFont
    },
    dropdown: {
      backgroundColor: theme.color.bodyBackground
    }
  };
});